import { useQuery } from '@tanstack/react-query';

import { CalendarEventModel } from '@/types/calendar';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export interface CommunityCalendarEventsQueryParams {
  community_id: number;
  start_date?: string;
  end_date?: string;
}

export interface CommunityCalendarEventsResponse {
  events: CalendarEventModel[];
  count: number;
}

const METHOD = 'GET';
const ENDPOINT = 'calendar-events/community/:communityId/all';
export const QUERY_KEY = (params: CommunityCalendarEventsQueryParams) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetCommunityCalendarEvents = (
  params: CommunityCalendarEventsQueryParams,
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token && !!params.community_id,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      const data = await handleApiCall<CommunityCalendarEventsResponse>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {
          communityId: params.community_id.toString(),
        }),
        undefined,
        { params: {
          start_date: params.start_date,
          end_date: params.end_date,
        }}
      );

      return data;
    },
  });
};